import {
  Component,
  OnInit
} from "@angular/core";
import { NavigationMenuService, LoggingService, LoaderService, PortalService } from "src/app/services";
import { Subscription } from "rxjs";
import { Helpers } from "src/app/helpers";
import { IPortalConfig } from "src/app/models";

@Component({
    selector: 'medpt-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})
export class ContactComponent implements OnInit {

  linkContent: string = '<div class="sm-loading text-center"></div>';
  isPortal: boolean = false;
  constructor(
    private navigationMenuService: NavigationMenuService,
    private loaderService: LoaderService,
    private portalService: PortalService) {

  let portalConfig = this.portalService.portalConfiguation.value;
    this.isPortal = !Helpers.isNullOrUndefined(portalConfig.PortalName);
    if (!this.isPortal) {
      this.loaderService.showLoader();
      this.navigationMenuService.getContactDetails().then((data) => {
        this.linkContent = data;
        this.loaderService.hideLoader();
      });
    }
  }

  ngOnInit(): void {
  }
}
